<template>
  <div>
    <h5 class="measurement-title mb-0"> {{ $t(`dashboard_new_evollu.parameters.optometry`) }} </h5>
    <span
      class="measurement-timestamp"> {{ $t('checkup_plus.reports.measurements.last_measurement_date', { date: moment(data.lastMeasurementTimestamp).format('DD/MM/YYYY HH:mm') })
      }} </span>

    <table class="w-100">
      <tr>
        <td>
          <div class="measurement-card h-100">
            <div class="title-container d-flex align-items-center mb-3">
              <img style="margin-right: 10px" src="~@/assets/check-up-reports/evollu-default/eye.svg">
              <div>
                <h5 class="card-title">{{ $t('checkup_plus.reports.measurements.optometry.astigmatism') }} -
                  {{ $t('checkup_plus.reports.measurements.optometry.left_eye') }}</h5>
              </div>
            </div>
            <span class="card-title">
              <span v-if="astigmatismLeftData">{{ astigmatismLeftData.value }} {{ astigmatismLeftData.units }} </span>
              <span v-else>N/A</span>
            </span>
            <br>
            <span class="card-description">
              <span v-if="astigmatismLeftData"> <span style="font-weight: bold">{{ astigmatismLeftData.previousValue }} {{ astigmatismLeftData.units
                }}</span> {{ $t('checkup_plus.reports.patient_overall_summary.card.on_the_last_test') }} </span>
            </span>
          </div>
        </td>
        <td>
          <div class="measurement-card h-100">
            <div class="title-container d-flex align-items-center mb-3">
              <img style="margin-right: 10px" src="~@/assets/check-up-reports/evollu-default/eye.svg">
              <div>
                <h5 class="card-title">{{ $t('checkup_plus.reports.measurements.optometry.astigmatism') }} -
                  {{ $t('checkup_plus.reports.measurements.optometry.right_eye') }}</h5>
              </div>
            </div>
            <span class="card-title">
              <span v-if="astigmatismRightData">{{ astigmatismRightData.value }} {{ astigmatismRightData.units
                }} </span>
              <span v-else>N/A</span>
            </span>
            <br>
            <span class="card-description">
              <span v-if="astigmatismRightData"> <span style="font-weight: bold">{{ astigmatismRightData.previousValue
                }} {{ astigmatismRightData.units
                }}</span> {{ $t('checkup_plus.reports.patient_overall_summary.card.on_the_last_test') }} </span>
            </span>
          </div>
        </td>
        <td>
          <div class="measurement-card h-100">
            <div class="title-container d-flex align-items-center mb-3">
              <img style="margin-right: 10px" src="~@/assets/check-up-reports/evollu-default/eye.svg">
              <div>
                <h5 class="card-title">{{ $t('checkup_plus.reports.measurements.optometry.duochrome') }} </h5>
              </div>
            </div>
            <span class="card-title">
              <span v-if="duochromeData">{{ duochromeData.value }} {{ duochromeData.units }} </span>
              <span v-else>N/A</span>
            </span>
            <br>
            <span class="card-description">
              <span v-if="duochromeData"> <span style="font-weight: bold">{{ duochromeData.previousValue
                }} {{ duochromeData.units
                }}</span> {{ $t('checkup_plus.reports.patient_overall_summary.card.on_the_last_test') }} </span>
            </span>
          </div>
        </td>
      </tr>
      <tr>
        <td>
          <div class="measurement-card h-100">
            <div class="title-container d-flex align-items-center mb-3">
              <img style="margin-right: 10px" src="~@/assets/check-up-reports/evollu-default/eye.svg">
              <div>
                <h5 class="card-title">{{ $t('checkup_plus.reports.measurements.optometry.chromatic') }} -
                  {{ $t('accounts.correct_answers') }}</h5>
              </div>
            </div>
            <span class="card-title">
              <span v-if="chromaticCorrectData">{{ chromaticCorrectData.value }} {{ chromaticCorrectData.units
                }} </span>
              <span v-else>N/A</span>
            </span>
            <br>
            <span class="card-description">
              <span v-if="chromaticCorrectData"> <span style="font-weight: bold">{{ chromaticCorrectData.previousValue
                }} {{ chromaticCorrectData.units
                }}</span> {{ $t('checkup_plus.reports.patient_overall_summary.card.on_the_last_test') }} </span>
            </span>
          </div>
        </td>
        <td>
          <div class="measurement-card h-100">
            <div class="title-container d-flex align-items-center mb-3">
              <img style="margin-right: 10px" src="~@/assets/check-up-reports/evollu-default/eye.svg">
              <div>
                <h5 class="card-title">{{ $t('checkup_plus.reports.measurements.optometry.chromatic') }} -
                  {{ $t('accounts.wrong_answers') }}</h5>
              </div>
            </div>
            <span class="card-title">
              <span v-if="chromaticWrongData">{{ chromaticWrongData.value }} {{ chromaticWrongData.units }} </span>
              <span v-else>N/A</span>
            </span>
            <br>
            <span class="card-description">
              <span v-if="chromaticWrongData"> <span style="font-weight: bold">{{ chromaticWrongData.previousValue
                }} {{ chromaticWrongData.units
                }}</span> {{ $t('checkup_plus.reports.patient_overall_summary.card.on_the_last_test') }} </span>
            </span>
          </div>
        </td>
        <td>
          <div class="measurement-card h-100">
            <div class="title-container d-flex align-items-center mb-3">
              <img style="margin-right: 10px" src="~@/assets/check-up-reports/evollu-default/eye.svg">
              <div>
                <h5 class="card-title">{{ $t('checkup_plus.reports.measurements.optometry.contrast') }} -
                  {{ $t('checkup_plus.reports.measurements.optometry.left_eye') }}</h5>
              </div>
            </div>
            <span class="card-title">
              <span v-if="contrastLeftData">{{ contrastLeftData.value }} {{ contrastLeftData.units }} </span>
              <span v-else>N/A</span>
            </span>
            <br>
            <span class="card-description">
              <span v-if="contrastLeftData"> <span style="font-weight: bold">{{ contrastLeftData.previousValue
                }} {{ contrastLeftData.units
                }}</span> {{ $t('checkup_plus.reports.patient_overall_summary.card.on_the_last_test') }} </span>
            </span>
          </div>
        </td>
      </tr>
      <tr>
        <td>
          <div class="measurement-card h-100">
            <div class="title-container d-flex align-items-center mb-3">
              <img style="margin-right: 10px" src="~@/assets/check-up-reports/evollu-default/eye.svg">
              <div>
                <h5 class="card-title">{{ $t('checkup_plus.reports.measurements.optometry.contrast') }} -
                  {{ $t('checkup_plus.reports.measurements.optometry.right_eye') }}</h5>
              </div>
            </div>
            <span class="card-title">
              <span v-if="contrastRightData">{{ contrastRightData.value }} {{ contrastRightData.units }} </span>
              <span v-else>N/A</span>
            </span>
            <br>
            <span class="card-description">
              <span v-if="contrastRightData"> <span style="font-weight: bold">{{ contrastRightData.previousValue
                }} {{ contrastRightData.units
                }}</span> {{ $t('checkup_plus.reports.patient_overall_summary.card.on_the_last_test') }} </span>
            </span>
          </div>
        </td>
        <td>
          <div class="measurement-card h-100">
            <div class="title-container d-flex align-items-center mb-3">
              <img style="margin-right: 10px" src="~@/assets/check-up-reports/evollu-default/eye.svg">
              <div>
                <h5 class="card-title">{{ $t('checkup_plus.reports.measurements.optometry.macular') }} -
                  {{ $t('checkup_plus.reports.measurements.optometry.left_eye') }}</h5>
              </div>
            </div>
            <span class="card-title">
              <span v-if="macularLeftData">{{ macularLeftData.value }} {{ macularLeftData.units }} </span>
              <span v-else>N/A</span>
            </span>
            <br>
            <span class="card-description">
              <span v-if="macularLeftData"> <span style="font-weight: bold">{{ macularLeftData.previousValue
                }} {{ macularLeftData.units
                }}</span> {{ $t('checkup_plus.reports.patient_overall_summary.card.on_the_last_test') }} </span>
            </span>
          </div>
        </td>
        <td>
          <div class="measurement-card h-100">
            <div class="title-container d-flex align-items-center mb-3">
              <img style="margin-right: 10px" src="~@/assets/check-up-reports/evollu-default/eye.svg">
              <div>
                <h5 class="card-title">{{ $t('checkup_plus.reports.measurements.optometry.macular') }} -
                  {{ $t('checkup_plus.reports.measurements.optometry.right_eye') }}</h5>
              </div>
            </div>
            <span class="card-title">
              <span v-if="macularRightData">{{ macularRightData.value }} {{ macularRightData.units }} </span>
              <span v-else>N/A</span>
            </span>
            <br>
            <span class="card-description">
              <span v-if="macularRightData"> <span style="font-weight: bold">{{ macularRightData.previousValue
                }} {{ macularRightData.units
                }}</span> {{ $t('checkup_plus.reports.patient_overall_summary.card.on_the_last_test') }} </span>
            </span>
          </div>
        </td>

      </tr>
      <tr>
        <td>
          <div class="measurement-card h-100">
            <div class="title-container d-flex align-items-center mb-3">
              <img style="margin-right: 10px" src="~@/assets/check-up-reports/evollu-default/eye.svg">
              <div>
                <h5 class="card-title">{{ $t('checkup_plus.reports.measurements.optometry.visual_acuity') }} -
                  {{ $t('checkup_plus.reports.measurements.optometry.left_eye') }}</h5>
              </div>
            </div>
            <span class="card-title">
              <span v-if="visualAcuityLeftData">{{ visualAcuityLeftData.value }} {{ visualAcuityLeftData.units
                }} </span>
              <span v-else>N/A</span>
            </span>
            <br>
            <span class="card-description">
              <span v-if="visualAcuityLeftData"> <span style="font-weight: bold">{{ visualAcuityLeftData.previousValue
                }} {{ visualAcuityLeftData.units
                }}</span> {{ $t('checkup_plus.reports.patient_overall_summary.card.on_the_last_test') }} </span>
            </span>
          </div>
        </td>
        <td>
          <div class="measurement-card h-100">
            <div class="title-container d-flex align-items-center mb-3">
              <img style="margin-right: 10px" src="~@/assets/check-up-reports/evollu-default/eye.svg">
              <div>
                <h5 class="card-title">{{ $t('checkup_plus.reports.measurements.optometry.visual_acuity') }} -
                  {{ $t('checkup_plus.reports.measurements.optometry.right_eye') }}</h5>
              </div>
            </div>
            <span class="card-title">
              <span v-if="visualAcuityRightData">{{ visualAcuityRightData.value }} {{ visualAcuityRightData.units
                }} </span>
              <span v-else>N/A</span>
            </span>
            <br>
            <span class="card-description">
              <span v-if="visualAcuityRightData"> <span style="font-weight: bold">{{ visualAcuityRightData.previousValue
                }} {{ visualAcuityRightData.units
                }}</span> {{ $t('checkup_plus.reports.patient_overall_summary.card.on_the_last_test') }} </span>
            </span>
          </div>
        </td>
      </tr>
      <tr v-for="elem in data.results">
        <td colspan="3">
          <div class="measurement-card h-100 d-flex justify--space-between">
            <div class="title-container d-flex align-items-center">
              <img style="margin-right: 10px" src="~@/assets/check-up-reports/evollu-default/warning_yellow.svg">
              <div>
                <h5 class="card-title">{{ $t('checkup_plus.reports.measurements.result') }}</h5>
              </div>
            </div>
            <span :style="{ color: elem.resultColour }">
              {{ elem.resultName }}
            </span>
          </div>

          <div class="measurement-card h-100 mt-2">
            <div class="title-container d-flex align-items-center mb-3">
              <img style="margin-right: 10px" src="~@/assets/check-up-reports/evollu-default/reference_values.svg">
              <div>
                <h5 class="card-title">
                  {{ $t('checkup_plus.reports.measurements.measurement_reference_values', { measurement: $t('dashboard_new_evollu.parameters.blood_pressure') })
                  }}</h5>
              </div>
            </div>
            <div>
              <table>
                <tr v-for="elem in elem.referenceValues">
                  <td>
                    {{ handleReferenceValuesCriterias(elem) }}
                  </td>
                  <td>
                    {{ elem.resultMatchingCriteria }}
                  </td>
                </tr>
              </table>
            </div>
          </div>

          <div class="measurement-card h-100 mt-2">
            <div class="title-container d-flex align-items-center mb-3">
              <img style="margin-right: 10px" src="~@/assets/check-up-reports/evollu-default/info_circle.svg">
              <div>
                <h5 class="card-title">{{ $t('checkup_plus.reports.patient_overall_summary.recommendation') }}</h5>
              </div>
            </div>
            <span class="card-text-normal">
            {{ elem.recommendations }}
          </span>
          </div>

        </td>
      </tr>
    </table>
  </div>
</template>
<script>
export default {
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
  data: function() {
    return {
      optometryTests: ['astigmatism', 'visual_acuity', 'contrast', 'macular', 'duochrome', 'chromatic'],
      astigmatismLeftData: null,
      astigmatismRightData: null,
      visualAcuityLeftData: null,
      visualAcuityRightData: null,
      contrastLeftData: null,
      contrastRightData: null,
      macularLeftData: null,
      macularRightData: null,
      duochromeData: null,
      chromaticCorrectData: null,
      chromaticWrongData: null,
    };
  },
  created() {
    this.data.measurementValues.forEach(elem => {
      if (elem.attributeCode === 'OPT_AST_L') {
        this.astigmatismLeftData = elem;
      } else if (elem.attributeCode === 'OPT_AST_R') {
        this.astigmatismRightData = elem;
      } else if (elem.attributeCode === 'OPT_DUOCH') {
        this.duochromeData = elem;
      } else if (elem.attributeCode === 'OPT_CHROM_W') {
        this.chromaticCorrectData = elem;
      } else if (elem.attributeCode === 'OPT_CHORM_CR') {
        this.chromaticWrongData = elem;
      } else if (elem.attributeCode === 'OPT_CONT_L') {
        this.contrastLeftData = elem;
      } else if (elem.attributeCode === 'OPT_CONT_R') {
        this.contrastRightData = elem;
      } else if (elem.attributeCode === 'OPT_MAC_R') {
        this.macularRightData = elem;
      } else if (elem.attributeCode === 'OPT_MAC_L') {
        this.macularLeftData = elem;
      } else if (elem.attributeCode === 'OPT_ACU_L') {
        this.visualAcuityLeftData = elem;
      } else if (elem.attributeCode === 'OPT_ACU_R') {
        this.visualAcuityRightData = elem;
      }
    });
  },
  methods: {
    handleReferenceValuesCriterias(elem) {
      var str = '';
      let index = 0;
      let criteriasLength = elem.criteriaList.length;
      if (elem.operator === 'AND') {
        elem.criteriaList.forEach(elem => {
          str += `${elem.attributeName} ${elem.criteria} `;
          ++index;
          if (index < criteriasLength) {
            str += '& ';
          }

        });
      }
      return str;
    },
  },
};
</script>
<style scoped lang="scss">
.measurement-card {
  padding: 20px;
  width: 100%;
  border: 1px solid lightgrey;
  border-radius: 15px;
  margin-bottom: 0;
}

table {
  width: 100%;
  height: 100%;
  table-layout: fixed;
}

td {
  height: 100%;
}

table td {
  padding-bottom: 10px;
}

table tr {
  margin-bottom: 10px;
}

table td:not(:first-child) {
  padding-left: 12px;
}

</style>
